<template>
  <div
    class="rounded-full border-4 border-white/30 text-[11px] leading-[11px] flex justify-center items-center relative"
    :style="componentStyles"
  >
    <svg class="absolute" :width="size" :height="size" :style="svgStyles">
      <circle
        class="fill-transparent"
        :stroke-dasharray="circleStrokeDasharray"
        :style="circleStyles"
        stroke-width="4"
        :r="normalizedRadius"
        :cx="radius"
        :cy="radius"
      />
    </svg>
    <div class="font-primary">{{ percentage }}</div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  percentage: number
  strokeColor?: string
  textColor?: string
}>()

const size = 30
const radius = size / 2
const normalizedRadius = radius - 2
const circumference = normalizedRadius * 2 * Math.PI

const componentStyles = {
  minWidth: `${size}px`,
  maxWidth: `${size}px`,
  height: `${size}px`,
  color: props.textColor || '#2D2D2D',
}

const svgStyles = {
  stroke: props.strokeColor || '#2D2D2D',
}

const strokeDashoffset = computed(
  () => circumference - (props.percentage / 100) * circumference
)

const circleStrokeDasharray = `${circumference} ${circumference}`
const circleStyles = computed(() => ({
  strokeDashoffset: strokeDashoffset.value,
}))
</script>

<style scoped>
circle {
  transition: stroke-dashoffset 0.3s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
  vector-effect: non-scaling-stroke;
}
</style>
